import { LegendPosition } from "../../../interfaces/print";
import { templateConfig } from "./templateConfig";

export const legendPositionTemplateConfMap = {
  [LegendPosition.Left]: templateConfig.MapLegendLeft,
  [LegendPosition.Right]: templateConfig.MapLegendRight,
  [LegendPosition.Under]: templateConfig.MapLegendBottom,
  [LegendPosition.Vertical]: templateConfig.LegendVertical,
  [LegendPosition.Horizontal]: templateConfig.LegendHorizontal,
};
